<template>
  <stacked-input
    :label="i18n.take"
    :required="required"
    :error="errors.take"
    :help="i18n.help"
  >
    <input
      type="text"
      :required="required"
      :value="value"
      @input="$emit('input', $event.target.value)"
    />
  </stacked-input>
</template>

<script>
import StackedInput from "../../../../Design/Forms/StackedInput";

export default {
  props: ["i18n", "required", "value", "errors"],
  components: { StackedInput },
};
</script>
